import {useLazyQuery} from '@apollo/client';
import {GET_DEFAULT_TT_FROM_CODE} from '../graphql/queries/getDefaultTtFromCode';

/**
 * 获取 TT 包牌始发地代码的 Hook
 * 通过仓库的 zipcode 查询对应的三段码，返回第一段作为 TT 业务的 fromCode
 */
export const useGetDefaultTtFromCode = () => {
    const [query, {loading, error, data}] = useLazyQuery<
        {getDefaultTtFromCode: string | null},
        {warehouseId: number}
    >(GET_DEFAULT_TT_FROM_CODE);

    const getDefaultTtFromCode = async (warehouseId: number): Promise<string | null> => {
        try {
            const result = await query({
                variables: {warehouseId},
            });
            return result.data?.getDefaultTtFromCode ?? null;
        } catch (err) {
            console.error('获取 TT fromCode 失败:', err);
            return null;
        }
    };

    return {
        getDefaultTtFromCode,
        loading,
        error,
        data: data?.getDefaultTtFromCode ?? null,
    };
};
